import { ITextDetails, IVariantTextFormat } from './types';

export default {
  openText: '- Less',
  closeText: '+ More',
  footer: <IVariantTextFormat>{
    title: <ITextDetails>{
      textV: 'T3',
      weightV: 'bold',
      colorV: 'Nero'
    },
    cta: <ITextDetails>{
      textV: 'T2',
      weightV: 'bold',
      colorV: 'Light_Grey'
    }
  },
  default: <IVariantTextFormat>{
    title: {
      textV: 'T4',
      weightV: 'bold',
      colorV: 'Nero'
    },
    cta: {
      textV: 'T2',
      weightV: 'bold',
      colorV: 'Pelorous'
    }
  },
  luxeDefault: <IVariantTextFormat>{
    title: {
      textV: 'T4',
      weightV: 'bold',
      colorV: 'Light_Black'
    },
    cta: {
      textV: 'T1',
      weightV: 'regular',
      colorV: 'Light_Black'
    }
  },
  iconText: <IVariantTextFormat>{
    title: {
      textV: 'T3',
      weightV: 'bold',
      colorV: 'Nero'
    },
    cta: {
      textV: 'T2',
      weightV: 'bold',
      colorV: 'Pelorous'
    }
  }
};
